import React, { useEffect } from "react";
import { BsArrowRight } from "react-icons/bs";
import { FaUserTie } from "react-icons/fa";
import { GiArcheryTarget } from "react-icons/gi";
import { FaGraduationCap } from "react-icons/fa";
import { MdPhoto } from "react-icons/md";
import { useInView } from "react-intersection-observer";
import { useAnimation, motion } from "framer-motion";

export const ExtraCard = ({ title, icon, width, height, bg }) => {
  return (
    <motion.div
      whileHover={{
        borderRadius: "50%",
        scale: "0.9",
        transition: {
          duration: "0.4",
          ease: "easeInOut",
        },
      }}
      className={` flex flex-col justify-center items-center  border-4 border-white cursor-pointer mr-1`}
      style={{
        backgroundColor: `${bg}`,
        height: `${height ? height : "170px"}`,
        width: `${width ? width : "170px"}`,
      }}
    >
      <motion.p className="font-bold text-white text-4xl">{icon}</motion.p>
      <motion.p className="font-bold text-white font-serif text-lg ">
        {title}
      </motion.p>
    </motion.div>
  );
};

const Extra = () => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: false,
  });

  const animation = useAnimation();

  const variants = {
    visible: { opacity: 1, scale: 1 },
    hidden: {
      opacity: 0,
      scale: 0.1,
      // y: 150,
    },
  };

  const variants2 = {
    visible: { opacity: 1, y: 0 },
    hidden: {
      opacity: 0,
      y: 30,
    },
  };

  const variants3 = {
    visible: { opacity: 1, y: 0 },
    hidden: {
      opacity: 0,
      y: 30,
    },
  };

  useEffect(() => {
    if (inView) {
      animation.start({
        opacity: 1,
        scale: 1,
        y: 0,
        // transition: {
        //   type: "spring",
        //   duration: 1,
        //   bounce: 0.3,
        // },
      });
    }
    if (!inView) {
      animation.start({
        opacity: 0,
        scale: 0,
        y: 50,
      });
    }
  }, [inView, animation]);

  return (
    <div ref={ref} className="my-4 bg-gray-100">
      <h1 className="text-center text-3xl font-serif my-10 pt-10">About Us</h1>
      <div className="px-2 md:px-6 flex justify-center flex-wrap gap-x-3">
        {/** Intro */}
        <div className="border-8 border-white  bg-white flex flex-col md:flex-row justify-center items-center w-full md:w-3/5">
          <motion.img
            src="/images/about.JPG"
            alt=""
            className="w-full md:w-3/5"
            style={{ height: "290px" }}
            animate={inView ? "visible" : "hidden"}
            variants={variants2}
            transition={{ duration: 0.6, ease: "easeIn" }}
          />
          <div>
            <motion.p
              className="p-3 text-sm font-serif"
              animate={inView ? "visible" : "hidden"}
              variants={variants3}
              transition={{ duration: 0.9, ease: "easeIn", delay: 0.5 }}
            >
              <span className="text-base font-semibold ">
                St.John High School
              </span>{" "}
              is an English Medium School with a Boarding Facility. It was
              founded by the UBA(Udaipur Baptist Association) on the 20th Aug,
              1988 at Embru Panthor(Khakchang Hati) near Killa. It was then
              shifted to Raio in 1991. It was upgraded to Senior Basic School
              1997 and to a High School in 1999. It is recognized by the
              Department of Education-Govt. of Tripura and was affiliated to
              TBSE and later it was converted to CBSE in 2015.
            </motion.p>
            <motion.button
              animate={inView ? "visible" : "hidden"}
              variants={variants3}
              transition={{ duration: 1.1, ease: "easeIn", delay: 1 }}
              className="ml-3 p-2 bg-yellow-400 flex items-center gap-x-2"
            >
              Read More <BsArrowRight />
            </motion.button>
          </div>
        </div>
        {/** Extra Info */}
        <div
          ref={ref}
          className="flex justify-center items-center gap-x-1 mt-10 md:mt-0"
        >
          <motion.div
            animate={inView ? "visible" : "hidden"}
            variants={variants}
            transition={{ duration: 1.5, ease: "easeOut", delay: 2.4 }}
          >
            <ExtraCard
              title="Principal's Desk"
              icon={<FaUserTie />}
              bg="#ffb500"
            />

            <ExtraCard
              title="Our Mission"
              icon={<GiArcheryTarget />}
              bg="#7566dc"
            />
          </motion.div>
          <motion.div
            animate={inView ? "visible" : "hidden"}
            variants={variants}
            transition={{ duration: 1.5, ease: "easeOut", delay: 2.4 }}
          >
            <ExtraCard title="Alumni" icon={<FaGraduationCap />} bg="#74aa50" />
            <ExtraCard
              title="Gallery"
              icon={<MdPhoto />}
              bg="#cd202c"
              width=""
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Extra;
